import { render, staticRenderFns } from "./PopMenu.vue?vue&type=template&id=2024852c&scoped=true"
import script from "./PopMenu.vue?vue&type=script&lang=js"
export * from "./PopMenu.vue?vue&type=script&lang=js"
import style0 from "./PopMenu.vue?vue&type=style&index=0&id=2024852c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024852c",
  null
  
)

export default component.exports